import { useCssVars as _useCssVars } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "application-component" }
const _hoisted_2 = {
  key: 0,
  class: "collapse-title"
}
const _hoisted_3 = { class: "collapse-header" }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "collapse-title collapse-title-question"
}
const _hoisted_6 = { class: "collapse-header" }
const _hoisted_7 = ["title", "onClick"]
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 1,
  class: "detail-editor"
}
const _hoisted_10 = { class: "dialog-footer" }

import { Delete } from '@element-plus/icons-vue'
import { useGlobalStore } from '@/store/modules/global'
import { useWritingStore } from '@/store/modules/writing'
import { useUserStore } from '@/store/modules/user'
import { CHAT_RAG_ID_MISSING_MESSAGE, createAbortController, resolveChatRagId, streamChat } from '@/api/analysis'
import { fetchExportNote } from '@/api/writing'
import { getDetailListDisplayQuestion, isAnnotationComponentExportItem, normalizeDetailListItem, normalizeDetailListItems } from '@/components/Application/detailList'
import { jsonParse } from '@/utils'
import { ElLoading, ElMessage } from 'element-plus'


export default {
  __name: 'DetailList',
  props: {
  readOnly: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => null
  },
  projectId: {
    type: String,
    default: ''
  },
  handleAddToDetailList: {
    type: Function,
    default: () => null
  },
  handleUpdateDetailList: {
    type: Function,
    default: () => null
  }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "v39ecf5ff": (_unref(fontSize))
}))

const globalStore = useGlobalStore()
const writingStore = useWritingStore()
const userStore = useUserStore()

const props = __props

const list = ref(props.readOnly ? [
  { question: '本发明解决的问题1' },
  { question: '本发明解决的问题2' },
] : normalizeDetailListItems(props.data ? jsonParse(props.data?.docResult || '[]') : []))

const fileList = computed(() => {
  return list.value.filter(v => v.type === 'file')
})

const questionList = computed(() => {
  return list.value.filter(v => v.type !== 'file')
})

const activeKey = ref(props.readOnly ? [0, 1] : []);
const openFooter = ref(false)

// 弹窗相关
const dialogVisible = ref(false)
const loading = ref(false)
const formRef = ref()
const formData = ref({
  question: '',
  answer: ''
})
const abortController = ref({})
const fontSize = computed(() => `${globalStore.fontSize}px`)

// 表单验证规则
const formRules = {
  question: [
    { required: true, message: '请输入问题名称', trigger: 'blur' },
    { min: 1, max: 100, message: '问题名称长度在 1 到 100 个字符', trigger: 'blur' }
  ],
}

const getQuestionTitle = (item = {}) => {
  return getDetailListDisplayQuestion(item) || item.question || ''
}

const handleChange = (key) => {
  if (props.readOnly) {
    // 如果是只读模式，恢复到之前的状态
    activeKey.value = [0, 1];
  }
}

const handlePreview = async (item) => {
  if (item.type !== 'file') {
    return
  }

  if (isAnnotationComponentExportItem(item)) {
    const loading = ElLoading.service({
      lock: true,
      text: '加载批注文档中...',
      background: 'rgba(0, 0, 0, 0.7)',
    })

    try {
      const file = await fetchExportNote(props.projectId)
      const target = file?.previewPath || file?.fileUrl

      if (!target) {
        ElMessage.warning('暂无可预览文件')
        return
      }

      window.open(target, '_blank')
    } finally {
      loading.close()
    }
    return
  }

  const target = item.previewPath || item.fileUrl
  if (!target) {
    ElMessage.warning('暂无可预览文件')
    return
  }

  window.open(target, '_blank')
}

const removeItem = (e, index, isQuestion = false) => {
  e.stopPropagation()
  e.preventDefault()
  const realIndex = isQuestion ? index + fileList.value.length : index
  if (props.readOnly) return
  if (abortController.value[realIndex]) {
    abortController.value[realIndex].abort()
    delete abortController.value[realIndex]
  }
  list.value.splice(realIndex, 1)
  props.handleUpdateDetailList(unref(list))
}

// 显示添加弹窗
const showAddDialog = () => {
  dialogVisible.value = true
  formData.value = {
    question: '',
    answer: ''
  }
  // 重置表单验证
  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

// 添加问题
const handleAddQuestion = async (event) => {
  // 阻止默认行为
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  
  if (!formRef.value) return
  
  try {
    await formRef.value.validate()
    loading.value = true

    // 添加新问题到列表
    const nextItem = normalizeDetailListItem({
      type: 'text',
      sourceKey: 'detail-list',
      sourceId: `detail-list:${Date.now()}`,
      question: formData.value.question
    })
    list.value.push(nextItem)
    
    // 自动展开新添加的项目
    activeKey.value.push(list.value.length - 1)
    
    // 关闭弹窗
    dialogVisible.value = false
    
    handleAnswer(nextItem.question, list.value.length - 1)
    
  } catch (error) {
    console.error('表单验证失败:', error)
  } finally {
    loading.value = false
  }
}

const handleAnswer = (question, index) => {
  if (abortController.value?.[index]) return

  const ragId = resolveChatRagId(writingStore.getStep2Info?.modelRagId)
  if (!ragId) {
    ElMessage.warning(CHAT_RAG_ID_MISSING_MESSAGE)
    return
  }

  abortController.value[index] = createAbortController()
  list.value[index].loading = true
  let chatStr = ''

  const onMessage = (message) => {
    console.log('onMessage', message)
    chatStr += message.answer
    list.value[index].answer = chatStr
    list.value[index].type = 'text'
    delete list.value[index].loading
    console.log(chatStr)
  }

  const onDone = () => {
    delete list.value[index].loading
    if (!chatStr) {
      list.value[index].answer = 'AI 助手未返回内容'
      list.value[index].type = 'text'
    }
    delete abortController.value[index]
    props.handleUpdateDetailList(unref(list))
  }

  const onError = (error) => {
    const message = error?.message || 'AI 助手请求失败'
    list.value[index].answer = `回答生成失败：${message}`
    list.value[index].type = 'text'
    delete list.value[index].loading
    delete abortController.value[index]
    ElMessage.error(message)
  }

  streamChat('/api/v1/chat-messages', {
    query: question,
    inputs: {
      quote: "",
      ragId
    },
    conversation_id: '',
    files: [],
    response_mode: "streaming",
    user: userStore.userInfo.id
  }, onMessage, onDone, abortController.value[index].signal, onError)
}

const handleExport = () => {
  writingStore.exportStepDetailList(props.projectId)
}

const handleUpdateAnswer = () => {
  if (props.readOnly || typeof props.handleUpdateDetailList !== 'function') {
    return
  }

  props.handleUpdateDetailList(unref(list))
}

const stopAllController = () => {
  Object.keys(abortController.value).forEach(index => {
    if (abortController.value[index]) {
      abortController.value[index].abort()
      delete abortController.value[index]
    }
  })
}

watch(() => props.data, (newVal) => {
  if (!newVal || (newVal?.docResult !== JSON.stringify(list.value) && !props.readOnly)) {
    const listLoading = list.value.filter(v => v.loading) || []
    if (listLoading.length) {
      stopAllController()
    }
    list.value = normalizeDetailListItems(jsonParse(newVal?.docResult || '[]')).concat(listLoading)
    list.value.forEach((v, i) => {
      if (v.loading) {
        handleAnswer(v.question, i)
        activeKey.value.push(i)
      }
    })
  }
}, { deep: true })

return (_ctx, _cache) => {
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_el_input = _resolveComponent("el-input")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "application-component-title" }, "交流清单", -1)),
    _createElementVNode("div", {
      class: "application-component-content",
      style: _normalizeStyle({fontSize: _unref(fontSize)})
    }, [
      (_unref(fileList).length)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "交底书批注文件："))
        : _createCommentVNode("", true),
      _createVNode(_component_el_collapse, {
        modelValue: _unref(activeKey),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(activeKey) ? (activeKey).value = $event : null)),
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fileList), (item, index) => {
            return (_openBlock(), _createBlock(_component_el_collapse_item, {
              key: `file-${index}`,
              class: "collapse-item",
              name: index
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (item.type === 'file')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: item.fileName,
                        onClick: _withModifiers($event => (handlePreview(item)), ["stop"])
                      }, _toDisplayString(item.fileName), 9, _hoisted_4))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_icon, {
                    onClick: _withModifiers(e => removeItem(e, index), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Delete))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_unref(questionList).length)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_5, "待审核问题："))
        : _createCommentVNode("", true),
      _createVNode(_component_el_collapse, {
        modelValue: _unref(activeKey),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(activeKey) ? (activeKey).value = $event : null)),
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questionList), (item, index) => {
            return (_openBlock(), _createBlock(_component_el_collapse_item, {
              key: `question-${index}`,
              class: "collapse-item",
              name: index
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (item.type === 'file')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: item.fileName,
                        onClick: _withModifiers($event => (handlePreview(item)), ["stop"])
                      }, _toDisplayString(`${index + 1}. ${item.fileName}`), 9, _hoisted_7))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        title: getQuestionTitle(item)
                      }, _toDisplayString(`${index + 1}. ${getQuestionTitle(item)}`), 9, _hoisted_8)),
                  _createVNode(_component_el_icon, {
                    onClick: _withModifiers(e => removeItem(e, index, true), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Delete))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              default: _withCtx(() => [
                (__props.readOnly || item.loading)
                  ? (_openBlock(), _createBlock(_component_el_skeleton, {
                      key: 0,
                      rows: 1,
                      animated: ""
                    }))
                  : (item.type === 'text')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_el_input, {
                          modelValue: item.answer,
                          "onUpdate:modelValue": $event => ((item.answer) = $event),
                          type: "textarea",
                          autosize: { minRows: 3, maxRows: 12 },
                          resize: "none",
                          placeholder: "请输入详细内容",
                          onBlur: handleUpdateAnswer
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 4),
    (!__props.readOnly)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['application-component-footer', { 'open': _unref(openFooter) }]),
          onMouseleave: _cache[3] || (_cache[3] = $event => (openFooter.value = false))
        }, [
          (_unref(openFooter))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: "application-component-footer-item",
                  onClick: handleExport
                }, "导出交流清单"),
                _createElementVNode("div", {
                  class: "application-component-footer-item",
                  onClick: showAddDialog
                }, "添加交流清单")
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "application-component-footer-trigger",
            onMouseenter: _cache[2] || (_cache[2] = $event => (openFooter.value = true))
          }, [
            _createVNode(_component_svg_icon, {
              name: "arrow-bottom.png",
              size: 130
            })
          ], 32)
        ], 34))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialogVisible),
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
      title: "添加交流清单",
      width: "500px",
      "close-on-click-modal": false,
      "append-to-body": true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = $event => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleAddQuestion,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode(" 确定 ", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(formData),
          rules: formRules,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "80px",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "问题名称",
              prop: "question"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).question,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_unref(formData).question) = $event)),
                  placeholder: "请输入问题名称",
                  maxlength: "100",
                  "show-word-limit": "",
                  onKeyup: _withKeys(_withModifiers(handleAddQuestion, ["prevent"]), ["enter"])
                }, null, 8, ["modelValue", "onKeyup"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

}